import { useEffect, useState } from "react";
import { Download, FileText, BookOpen } from "lucide-react";
import { api } from "../lib/api";
import { recapPdfUrl, recapDateFr } from "../lib/recaps";
import { IMG } from "../lib/images";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/motion";

export default function Recaps() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/recaps").then(({ data }) => setItems(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHeader
        testid="recaps-header"
        eyebrow="Le Recap'"
        titleLines={["Le résumé du samedi,", "à relire et partager"]}
        intro="Chaque semaine, retrouvez ici le « Recap' » : le résumé de la prédication du samedi précédent, en PDF, à télécharger librement."
        image={IMG.enseignement}
      />
      <section className="py-16 sm:py-24">
        <div className="container-site mx-auto max-w-3xl">
          {loading && <p className="text-sm text-stone-500">Chargement…</p>}
          {!loading && !items.length && (
            <div className="card-warm border-dashed p-12 text-center">
              <BookOpen className="mx-auto h-7 w-7 text-terracotta" />
              <p className="mt-5 font-serif text-xl font-medium text-obsidian">Le premier Recap' arrive bientôt</p>
              <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-stone-500">
                Le résumé de la prédication du samedi sera publié ici chaque semaine.
              </p>
            </div>
          )}
          <div className="space-y-4">
            {items.map((r, i) => (
              <Reveal key={r.id} delay={Math.min(i * 0.06, 0.3)}>
                <article data-testid={`recap-card-${r.id}`} className="card-warm flex flex-wrap items-center gap-5 p-6 sm:p-7">
                  <span className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-terracotta-soft text-terracotta">
                    <FileText className="h-6 w-6" />
                  </span>
                  <div className="min-w-0 flex-1">
                    <h2 className="font-serif text-lg font-semibold tracking-tight text-obsidian sm:text-xl">{r.title}</h2>
                    <p className="mt-1 text-sm capitalize text-stone-500">{recapDateFr(r.date)}</p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <a
                      data-testid={`recap-download-${r.id}`}
                      href={recapPdfUrl(r)}
                      download
                      className="btn-primary !px-5 !py-2.5 !text-xs"
                    >
                      <Download className="h-4 w-4" />
                      Télécharger le PDF
                    </a>
                    <a
                      data-testid={`recap-read-${r.id}`}
                      href={recapPdfUrl(r)}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-outline !px-5 !py-2.5 !text-xs"
                    >
                      Lire en ligne
                    </a>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
